// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","logo":"Header_logo__UsziS","mobImage":"Header_mobImage__+9+9q","desktopImage":"Header_desktopImage__N1+yz"};